export enum EmploymentForm {
  B2B,
  Permanent,
  Commission,
  CommissionWithStudentStatus,
  SpecificTaskContract
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/employment-form.enum.ts